class ObjectPivotLink {
    constructor() {
        this._object = null;

        this._trPos = new THREE.Vector3();
        this._trEuler = new THREE.Euler();
        this._trQuat = new THREE.Quaternion();
        this._trScale = new THREE.Vector3();

        this._relPos = new THREE.Vector3();
    }

    attach(object, pivot) {
        if (object && pivot) {
            this._object = object;

            this._trPos.copy(pivot).applyMatrix4(object.matrix);
            this._trEuler.copy(object.rotation);
            this._trQuat.copy(object.quaternion);
            this._trScale.copy(object.scale);

            this._relPos.copy(pivot).multiplyScalar(-1);
        } else {
            this._object = null;
        }
    }

    setPosition(pos) {
        this._trPos.copy(pos);
        this._updateObjectPosition();
    }

    setEuler(euler) {
        this._trEuler.copy(euler);
        this._trQuat.setFromEuler(euler);
        this._object.rotation.copy(euler);
        this._updateObjectPosition();
    }

    setQuaternion(quat) {
        this._trEuler.setFromQuaternion(quat, this._trEuler.order);
        this._trQuat.copy(quat);
        this._object.quaternion.copy(quat);
        this._updateObjectPosition();
    }

    setScale(scale) {
        this._trScale.copy(scale);
        this._object.scale.copy(scale);
        this._updateObjectPosition();
    }

    _updateObjectPosition() {
        this._object.position
            .copy(this._relPos)
            .multiply(this._trScale)
            .applyQuaternion(this._trQuat)
            .add(this._trPos);
    }

    getPosition(pos = new THREE.Vector3()) {
        return pos.copy(this._trPos);
    }

    getEuler(euler = new THREE.Euler()) {
        return euler.copy(this._trEuler);
    }

    getQuaternion(quat = new THREE.Quaternion()) {
        return quat.copy(this._trQuat);
    }

    getScale(scale = new THREE.Vector3()) {
        return scale.copy(this._trScale);
    }
}

export default ObjectPivotLink;
